import { IAdminFlight, TFlightCategory } from '../../../../../../../store/admin/eventFlights/store';

type TGetEmptyFlight = (eventId: number | string, category: TFlightCategory) => IAdminFlight;

export const getEmptyFlight: TGetEmptyFlight = (eventId, category) => ({
  ageLower: undefined,
  ageUpper: undefined,
  category,
  event: Number(eventId),
  gender: '',
  handicapLower: undefined,
  handicapUpper: undefined,
  id: -1,
  name: ''
});
